<div class="columns-config">
  <cx-accordion [title]="'Configurar colunas'" class="w-100" [style]="'white'" [iconStyle]="'arrow'">
    <div class="columns-config__content">
      @for (col of columns(); track col.field) {
        <cx-switcher [id]="col.field" (checkedChange)="onCheck($event, col.field)" [checked]="col.enabled">
          <span class="columns-config__content--label">{{ col.field === PRODUCT_LIST_FIELD.INVOICE_AMOUNT ? invoiceAmountLabel() : col.label }}</span>
        </cx-switcher>
      }
    </div>
  </cx-accordion>
</div>
